import { AxisBottom } from '../../../primitives/axis/axis/AxisBottom';
import { AxisLeft } from '../../../primitives/axis/axis/AxisLeft';
import { useBarData } from '../providers/data';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function BarAxes() {
  const {
    xScale,
    yScale,
    height,
    width
  } = useBarData();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(AxisBottom, {
      scale: xScale,
      top: height,
      left: width
    }), /*#__PURE__*/_jsx(AxisLeft, {
      scale: yScale
    })]
  });
}